import type { BusinessRelationTypeResponse } from 'pco-product-service-internal-consumer';
import { brsApi } from 'api';

export const getBrType = async (brUid: string): Promise<BusinessRelationTypeResponse> => {
  return await brsApi.getBrType({ brUid });
};
